import { render, staticRenderFns } from "./warehouse-cooperative.vue?vue&type=template&id=3830448c"
import script from "./warehouse-cooperative.vue?vue&type=script&lang=js"
export * from "./warehouse-cooperative.vue?vue&type=script&lang=js"
import style0 from "./warehouse-cooperative.vue?vue&type=style&index=0&id=3830448c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports